<template>
  <v-btn
    class="rounded-r-lg rounded-l-0 pa-0 modalButton"
    :disabled="!pickerApiLoaded"
    min-width="40"
    @click="handleButtonClick"
  >
    <v-icon color="white" class="px-0">
      mdi-google-drive
    </v-icon>
  </v-btn>
</template>

<script>

export default {
  props: {
    pdf: {
      type: Boolean,
      default: false
    },
    images: {
      type: Boolean,
      default: false
    }
  },
  emits: ['picked'],
  data() {
    return {
      /* clientId: '401740940263-jd5r8n5p8d99lcj0n5mdqnbeero7m0er.apps.googleusercontent.com',
      // scope: 'https://www.googleapis.com/auth/drive',
      scope: 'https://www.googleapis.com/auth/drive.readonly',
      developerKey: 'AIzaSyCJLOSV3Hsa82EybqIoBYeWCNlOmVm_w8g', */
      clientId: this.$store.state.remoteConfig.googlePicker.clientId,
      scope: this.$store.state.remoteConfig.googlePicker.scope,
      developerKey: this.$store.state.remoteConfig.googlePicker.developerKey,

      picked: {},
      pickerApiLoaded: false,
      oauthToken: ''

    }
  },
  mounted() {
    if (!window.gapi) { return console.warn('Google API not loaded') }
    window.gapi.load('auth2')
    window.gapi.load('client')
    window.gapi.load('picker', () => {
      this.pickerApiLoaded = true
      window.gapi.client.load('drive', 'v3')
    })
  },
  methods: {
    handleAuthResult(authResult) {
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token
        this.createPicker()
      } else {
        return console.warn(authResult.details)
      }
    },
    handleButtonClick() {
      window.gapi.auth2.authorize({
        client_id: this.clientId,
        scope: this.scope
      }, this.handleAuthResult)
    },
    createPicker() {
      if (this.pickerApiLoaded && this.oauthToken) {
        // eslint-disable-next-line
        const pickerBuilder = new google.picker.PickerBuilder()
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey(this.developerKey)
        // eslint-disable-next-line
          .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
          .setCallback(this.pickerCallback)
        if (this.pdf) {
          // eslint-disable-next-line
          pickerBuilder.addView(google.picker.ViewId.PDFS)
        }
        if (this.images) {
          // eslint-disable-next-line
          pickerBuilder.addView(google.picker.ViewId.DOCS_IMAGES)
        }
        this.$emit('build', pickerBuilder)
        // eslint-disable-next-line
        if (!this.$listeners.build) { pickerBuilder.addView(google.picker.ViewId.DOCS) }

        const picker = pickerBuilder.build()
        picker.setVisible(true)
      }
    },

    async pickerCallback(data) {
      if (data.action === window.google.picker.Action.PICKED) {
        const docs = data.docs

        const URL = 'https://www.googleapis.com/drive/v3/files'
        const FIELDS = 'name, mimeType, modifiedTime'
        const getFile = async (fileId) => {
          const { gapi: { auth, client: { drive: { files } } } } = window
          const { access_token: accessToken } = auth.getToken()
          const fetchOptions = { headers: { Authorization: `Bearer ${accessToken}` } }

          const {
            result: { name, mimeType, modifiedTime }
          } = await files.get({ fileId, fields: FIELDS })

          const blob = await fetch(`${URL}/${fileId}?alt=media`, fetchOptions).then(res => res.blob()
          )

          const fileOptions = {
            type: mimeType,
            lastModified: new Date(modifiedTime).getTime()
          }

          return new File([blob], name, fileOptions)
        }
        // const fileArray = await docs.map(x => getFile(x.id))
        const fileArray = []
        docs.forEach(async x => {
          const f = await getFile(x.id)
          fileArray.push(f)
        })
        this.$emit('picked', fileArray)
      }
    }

  }
}

</script>

<style scoped>
.drive-btn {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  padding: 0 !important;
  /* min-width: 35px !important;
   */
  /* width: 5px !important; */
  /* margin-left: 1px; */
}
</style>
